import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

import WelcomeScreen from '@/components/layout/WelcomeScreen';
import { useSession } from '@/contexts/SessionContext';

const SLIDE_EASE = [0.32, 0.72, 0, 1] as const;
const SLIDE_DURATION = 0.5;

export default function WelcomeView() {
  const navigate = useNavigate();
  const session = useSession();

  // The welcome screen is a logged-out-only view — signing in from it IS the
  // continue action, so a ready session goes straight to the lobby.
  useEffect(() => {
    if (session.status === 'ready') {
      navigate('/lobby', { replace: true });
    }
  }, [session.status, navigate]);

  if (session.status !== 'signedOut') return null;

  return (
    <motion.div
      className="fixed inset-0 z-20 overflow-y-auto"
      initial={{ x: 0 }}
      animate={{ x: 0 }}
      exit={{ x: '-100%' }}
      transition={{ duration: SLIDE_DURATION, ease: SLIDE_EASE }}
    >
      <WelcomeScreen onLogin={() => navigate('/sign-in')} />
    </motion.div>
  );
}
